module.exports = __webpack_public_path__ + "img/1.0456e3dc.png";